/** Honest advisory: approval is a record only. There is no contractor address and no check printing or mailing in this release. */
export function ContractorCheckNote() {
  return (
    <div className="wc-advisory" role="note" data-testid="contractor-check-note">
      <span aria-hidden="true">✉</span>
      <span>
        Check printing and mailing are not enabled in this release. Approving a contractor payment batch records the approval only — no check is
        printed, mailed or delivered, and no money moves.
      </span>
    </div>
  );
}
